<template>
  <v-snackbar v-model="visible" color="yellow lighten-4" :timeout="timeout">
    <span class="black--text">
      <v-icon class="mr-1 pb-1" :color="this.error ? 'red' : ''">{{ this.error?'mdi-alert-circle':'mdi-information' }}</v-icon>
      <span v-html="text"/>
    </span>
    <v-btn color="blue" text @click="hide">
      <v-icon class="pr-0">mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
  export default {
    data: () => ({
      visible: false,
      text: '',
      error: false,
      timeout: 4000,
    }),
    methods: {
      show (text, error) {
        this.text = text
        this.error = error
        this.visible = true
      },
      hide () {
        this.visible = false
      }
    }
  }
</script>
